import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { CreateAssociatedFormComponent } from '../create-associated-form/create-associated-form.component';
import { SelectTemplateAssociatedOtherFormComponent } from '../select-template-associated-other-form/select-template-associated-other-form.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'manage-associated-other-form',
  templateUrl: './manage-associated-other-form.component.html',
  styleUrls: ['./manage-associated-other-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageAssociatedOtherFormComponent implements OnInit, OnDestroy {
  selectDOntAdd = false;
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  @Input() data;
  @Input() currentuserId;
  @Input() is_mx_btn_needed = false;

  @Input() manageType = 'contact';
  @Input() is_loading;
  @Input() associate_form_list = [];
  @Input() currentStep = 0;
  @Input() action_type_config_list = [];

  subscription: Subscription = new Subscription();
  @Output('getUpdatedData') getUpdatedData: EventEmitter<any> = new EventEmitter();
  constructor(private dialog: MatDialog, private cd: ChangeDetectorRef, private documentService: DocumentService) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  selectTemplate() {
    const sharedDialogRef = this.dialog.open(SelectTemplateAssociatedOtherFormComponent, {
      width: '680px',
      maxWidth: '90%',
      data: {
        manageType: this.manageType,
        currentStep: this.currentStep,
        action_type_config_list: this.action_type_config_list,
        templateList: [],
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation?.success) {
          this.createForm(confirmation.id);
        }
      })
    );
  }
  createForm(id) {
    const sharedDialogRef = this.dialog.open(CreateAssociatedFormComponent, {
      width: '680px',
      maxWidth: '90%',
      data: {
        action_type_current: this.action_type_config_list[this.currentStep],
        ...this.data,
        manageType: this.manageType,
        selectedId: id,
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation?.success) {
          this.getUpdatedData.emit();
        }
      })
    );
  }
  deleteUserFormAssociation(id, form_name, item) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Remove',
        materialIcon: 'delete',
        text: `Are you sure you want to remove ${form_name}?`,
        proceedTitle: 'Remove',
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService.deleteUserFormAssociation(this.currentuserId, item.formid, item.associatedformid).subscribe((result) => {
              this.getUpdatedData.emit();
              this.cd.markForCheck();
            })
          );
        }
      })
    );
  }

  ngOnInit(): void {}
}
